import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StyledBaMenuItem } from '@bingads-webui-react/global-menu';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { DirectionalHint } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { fromLegacyTimeZone } from '@bingads-webui-universal/time-zone-converter';
import { util } from '@bingads-webui-campaign/reports-v4-shared';


function getReportsV4MenuItemElementsStyles() {
  return {
    ReportsV4MenuItem: {
      height: '48px',
      '& > a[role=menuitem]': {
        height: '48px !important',
        '& > div': {
          paddingTop: 0,
          width: 'auto',
        },
      },
      '& .ms-TooltipHost': {
        height: '48px',
        width: 'auto',
        display: 'flex',
        borderBottom: '1px solid #F3F2F1',
      },
      '& .report-v4-rencent-report-name': {
        display: 'inline-block',
        maxWidth: '230px',
        minWidth: '230px',
        overflow: 'hidden',
        lineHeight: '48px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
      '& .report-v4-rencent-report-date': {
        color: '#605E5C',
        display: 'inline-block',
        marginLeft: '4px',
        lineHeight: '48px',
      },
    },
  };
}


const ReStyledBaMenuItem = withDefaultStyles(
  props => (<StyledBaMenuItem
    id={props.key}
    {...props}
    customizedClass={classNames([props.classes.ReportsV4MenuItem, 'reports-v4-bar-recent-report'])}
  />),
  getReportsV4MenuItemElementsStyles
);


export function RecentReportMenuItem(props) {
  const {
    classes, report, reportTypeMapping, onClick, navigate, serverContext, closeDropdown, headerId,
  } = props;
  const i18n = useContext(I18nContext);

  const renderProps = {};
  if (report.Id) { // Saved report
    renderProps.pathname = `reports-v4/edit/${report.Id}`;
    renderProps.name = report.Name;
  } else { // Default report
    const config = reportTypeMapping[report.ReportType];
    if (!config) {
      // The report is not available due to permission or scope
      return null;
    }
    renderProps.pathname = config.route;
    renderProps.name = i18n.getString(config.name);
  }

  return (
    <ReStyledBaMenuItem
      className={classNames([classes.menuItem, classes.toggleable])}
      key={report.Id + report.ReportType}
      menuItemKey={report.Id + report.ReportType}
      calloutPlacement="right"
      closeDropdown={closeDropdown}
      customizedOnClick={() => {
        navigate(renderProps.pathname);
        onClick();
      }}
      directionalHint={DirectionalHint.rightCenter}
      headerId={headerId}
    >
      <span className="report-v4-rencent-report-name">
        {renderProps.name}
      </span>
      <span className="report-v4-rencent-report-date">
        {i18n.getString(_TL_('Last accessed'))}
        {' '}
        {report.LastAccessedAt ?
          util.reformatDate(i18n, report.LastAccessedAt, fromLegacyTimeZone(serverContext.CurrentAccount.TimeZone), 'yMd')
          : '-'}
      </span>
    </ReStyledBaMenuItem >
  );
}

RecentReportMenuItem.propTypes = {
  serverContext: PropTypes.shape({}).isRequired,
  closeDropdown: PropTypes.func.isRequired,
  classes: PropTypes.shape({}).isRequired,
  report: PropTypes.shape({}).isRequired,
  reportTypeMapping: PropTypes.shape({}).isRequired,
  navigate: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  headerId: PropTypes.string,
};

RecentReportMenuItem.defaultProps = {
  onClick: _.noop,
  headerId: undefined,
};

